export enum ArchiveFileStatus {
  OK = 'OK',
  NOT_CREATED = 'NOT_CREATED',
  DRAFT = 'DRAFT',
  WAIT_SIGN = 'WAIT_SIGN',
  WAIT_SEAL = 'WAIT_SEAL',
  REJECT = 'REJECT',
  CANCLE = 'CANCLE',
  UPDATE = 'UPDATE',
  ERROR = 'ERROR',
}

export const ArchiveFileStatusMap: { [key in ArchiveFileStatus]: string } = {
  [ArchiveFileStatus.OK]: 'OK',
  [ArchiveFileStatus.NOT_CREATED]: '未创建',
  [ArchiveFileStatus.DRAFT]: '草稿',
  [ArchiveFileStatus.WAIT_SIGN]: '待签署',
  [ArchiveFileStatus.WAIT_SEAL]: '待盖章',
  [ArchiveFileStatus.REJECT]: '已退回',
  [ArchiveFileStatus.CANCLE]: '已撤回',
  [ArchiveFileStatus.UPDATE]: '已更新',
  [ArchiveFileStatus.ERROR]: '错误',
};

export const ArchiveFileStatusOptions = [
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.OK],
    value: ArchiveFileStatus.OK,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.NOT_CREATED],
    value: ArchiveFileStatus.NOT_CREATED,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.DRAFT],
    value: ArchiveFileStatus.DRAFT,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.WAIT_SIGN],
    value: ArchiveFileStatus.WAIT_SIGN,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.WAIT_SEAL],
    value: ArchiveFileStatus.WAIT_SEAL,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.REJECT],
    value: ArchiveFileStatus.REJECT,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.CANCLE],
    value: ArchiveFileStatus.CANCLE,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.UPDATE],
    value: ArchiveFileStatus.UPDATE,
  },
  {
    label: ArchiveFileStatusMap[ArchiveFileStatus.ERROR],
    value: ArchiveFileStatus.ERROR,
  },
];
